import React, { RefObject } from 'react'
import { VisibleMessage, MessageAnimType } from '../Messages'
import {
  getElByUid,
  getMsgByType,
  getMessageSize,
  getWrapperPaddingBottom,
} from './utils'

export const animateNewCalc = (
  visibleMessages: VisibleMessage[],
  setVisibleMessages: React.Dispatch<React.SetStateAction<VisibleMessage[]>>,
  ref: RefObject<HTMLDivElement>
) => {
  const msg = getMsgByType(visibleMessages, MessageAnimType.NEW_CALC)

  if (!msg || !ref.current) {
    return
  }

  // console.log('NEW_CALC', msg);

  const [, height] = getMessageSize(ref, msg.uid)

  const wrapperHeight = ref.current.offsetHeight
  const wrapperParentHeight = (ref.current.parentElement as HTMLDivElement)
    .offsetHeight
  const newWrapperHeight = wrapperHeight + height

  const move =
    newWrapperHeight > wrapperParentHeight
      ? Math.min(newWrapperHeight - wrapperParentHeight, height)
      : 0

  const bottomShift = -height + move + getWrapperPaddingBottom(ref)

  // console.log('NEW_CALC koniec', msg);

  setVisibleMessages(
    visibleMessages.map(m =>
      m.uid != msg.uid
        ? {
            ...m,
            animType: MessageAnimType.MOVE,
            translate: [0, -move],
          }
        : {
            ...m,
            animType: MessageAnimType.NEW_ENTER,
            bottomShift,
          }
    )
  )
}

export const animateNewEnter = (
  visibleMessages: VisibleMessage[],
  setVisibleMessages: React.Dispatch<React.SetStateAction<VisibleMessage[]>>,
  setAnimating: React.Dispatch<React.SetStateAction<boolean>>,
  ref: RefObject<HTMLDivElement>,
  scrollToBottomOffset: () => void
) => {
  const msg = getMsgByType(visibleMessages, MessageAnimType.NEW_ENTER)

  if (!msg) {
    return
  }

  // console.log('NEW_ENTER', msg);

  const el = getElByUid(ref, msg.uid)

  if (!el) {
    return
  }

  const onEnd = () => {
    // console.log('NEW_ENTER koniec', msg);

    setVisibleMessages(
      visibleMessages.map(m => ({
        ...m,
        animType: MessageAnimType.NONE,
      }))
    )

    setAnimating(false)
    scrollToBottomOffset()
    ;(el as HTMLDivElement).removeEventListener('animationend', onEnd)
  }

  ;(el as HTMLDivElement).addEventListener('animationend', onEnd)
}
